{
  "select_plan": {
    "title": "Please select a plan",
    "footer": "Learn more about billing",
    "free_trial": "Free for 14 days",
    "cancel_any_time": "Cancel any time",
    "expert_support": "Expert support included",
    "need_help": "Need help or have questions?",
    "contact_support": "Speak with our team"
  },
  "change_plan": {
    "title": "Change plan",
    "description": "Compare plans and choose the one that fits your business.",
    "footer": "Learn more about billing"
  },
  "errors": {
    "load_plans": "Unable to load billing plans. Please try again."
  }
}
